var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKidsAccount(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0693359,
    y: 0.383789,
    width: 11.8605,
    height: 11.9767,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1076_4684",
    transform: "translate(0 0.00485435) scale(0.01 0.00990291)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1076_4684",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAABmJLR0QA/wD/AP+gvaeTAAADGUlEQVR4nO3cv4tUZxiG4fsdFTVBQSQgCyIaXDS2Kga0s9DSIkJIb7aw8E+IhZhSSCqtFSuxs7FLoVGsxd9FUAwhJkYWccE8FrPKupmw455v2Gd2n6vaOZx5+c65l/mWGXaKBiStAnYCn7eYN4amgQdV9bbroOo6QNJG4Dqwr+usMXcLOFxVr7oM6TVYyPckBsB++veikxZBdjSYsVx82XVAiyDRUIKYSRAzCWImQcwkiJkEMZMgZhLETIKYSRAzCWImQcwkiJkEMZMgZhLETIKYSRAzCWImQcwkiJkEMZMgZhLETIKYSRAzCWImQcwkiJkEMbN67gNJmxYxY22jtSwHaxdzD6vqrw8/A0j6FvgJ2NxubfEJ/gROVtXlmi36DFi3xIta6V4DEz36/z2bGEtvPTDZIxu7k16rGH8DV4E7jeaNkzv0r/1li2EtgjwF9lTVsaraC5xuMHNc/FBVe6vqGLCH/l7cSYsgF6pq7kLOAjMN5rqboX+tAFTVU+BC16Etgvw+90FVvQFeNJjr7kVVzf/Fe951aDZ0MwliJkHMJIiZBDGTIGYSxEyCmEkQMwliJkHMrF74lEU5w/L/ytjpUQwdSZCq+nkUc1eCvGSZSRAzCWJmJHuIpJvAF6OYbeSPqjrQeuio/sraBmwZ0WwXn41iaF6yzCSImQQxkyBmEsRMgphJEDMJYiZBzCSImQQxkyBmEsRMgphpEWTQW/hrGsx1N+gaO193iyAH5z6Q9BUr4wsINkvaNe/YwYFnfoIWH1Adl/QQuAhsBc41mDkurkg6BfwGfAd803VgSToA3Og6KJr4Opu6mR7wz1IvIj542QPuAbeXeiXBr8C991/PtAE4AUwOOHE3cGjesWv0N7L4f1uBo/OO/QLcHXDufeB8Vb1acKqkKf3Xke7rXd4kHRlw36YWel42dTMJYiZBzCSImQQxkyBmEsRMgphJEDMJYiZBzAwTREMei48t6r4NE+TxkMfiY08GHHvUeaqkknRp9t3KfyWdXfhZASDpx9l7JkkXJVXL4dslTTQbuEJImpC0fdjz3wHRrMfDmEBbKAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKidsAccount);
export default __webpack_public_path__ + "static/media/kids-account.4e5521e2db3fac540e79b61d2a5796f6.svg";
export { ForwardRef as ReactComponent };